var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1C0 0.447715 0.447715 0 1 0H11C11.2673 0 11.5234 0.106988 11.7113 0.29709L20.1092 8.795L20.1104 8.79623C21.2718 9.96583 21.272 11.8533 20.111 13.0232L20.1092 13.025L13.1275 20.1202C12.5648 20.6835 11.8012 21 11.005 21C10.2108 21 9.44907 20.6851 8.88677 20.1244L0.300274 11.7144C0.108228 11.5263 0 11.2688 0 11V1ZM2 2V10.5797L10.2975 18.7067C10.4851 18.8944 10.7396 19 11.005 19C11.2694 19 11.5229 18.8953 11.7103 18.709L11.7125 18.7067L18.6872 11.6186L18.6908 11.615C19.0785 11.225 19.0785 10.595 18.6908 10.205L18.6887 10.2029L10.5823 2H2Z",
    fill: "#8B8C90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5C8 7.32843 7.32843 8 6.5 8C5.67157 8 5 7.32843 5 6.5C5 5.67157 5.67157 5 6.5 5C7.32843 5 8 5.67157 8 6.5Z",
    fill: "#8B8C90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.551d3824.svg";
export { ForwardRef as ReactComponent };